<template>
  <div>
    <h4 class="mb-2 mt-2">{{ $t('alta usuario') }}:</h4>
    <p class="mb-4">{{ $t('texto_alta_usuario') }}</p>

    <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
      <label class="font-weight-normal">
        {{ $t('nombre') }}
        <span class="required">*</span>
      </label>
      <input
        type="text"
        class="woocommerce-Input woocommerce-Input--text input-text"
        v-model="nuevoUsuario.name"
      />
    </p>
    <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
      <label class="font-weight-normal">
        {{ $t('apellidos') }}
        <span class="required">*</span>
      </label>
      <input
        type="text"
        class="woocommerce-Input woocommerce-Input--text input-text"
        v-model="nuevoUsuario.apellidos"
      />
    </p>

    <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
      <label class="font-weight-normal">
        {{ $t('email') }}
        <span class="required">*</span>
      </label>
      <input
        type="text"
        class="woocommerce-Input woocommerce-Input--text input-text"
        v-model="nuevoUsuario.email"
      />
    </p>
    <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
      <label class="font-weight-normal">
        {{ $t('contrasena') }}
        <span class="required">*</span>
      </label>
      <input
        type="text"
        class="woocommerce-Input woocommerce-Input--text input-text"
        v-model="nuevoUsuario.password"
      />
    </p>
    <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
      <label class="font-weight-normal">
        {{ $t('confirmar contrasena') }}
        <span class="required">*</span>
      </label>
      <input
        type="text"
        class="woocommerce-Input woocommerce-Input--text input-text"
        v-model="nuevoUsuario.c_password"
      />
    </p>
    <p>
      <button
        type="submit"
        class="woocommerce-Button button float-right"
        @click="registro"
      >{{ $t('registrarse') }}</button>
    </p>    

    <div class="clear mb-5"></div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
//import UserPhone from "./User-phone.vue";
//import UserAddress from "./User-address.vue";

export default {
  components: {
   // UserPhone,
   // UserAddress
  },
  data: function() {
    return {
      nuevoUsuario: {
        name: "",
        apellidos: "",
        email: "",
        password: "",
        c_password: ""
      }
    };
  },
  computed: {
    
  },
  methods: {
    ...mapActions("account", ["register"]),
    registro() {
      // TODO: 05/08/2019 Manejar el alta del usuario 
      // TODO: 19/08/2019 Notificación y gestión de MAIL    
      if (this.nuevoUsuario.password != this.nuevoUsuario.c_password) {
        alert("La contraseña no coincide");
      }
      this.register(this.nuevoUsuario);
    }
  },
  mounted() {}
};
</script>

